import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUserStockRewards from '@/types/table/platformUserStockRewards';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserStockRewardsData extends PlatformUserStockRewards {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserStockRewardsController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserStockRewardsData>>(API_CONTEXT + '/app/platformUserStockRewards/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserStockRewardsData>(API_CONTEXT + '/app/platformUserStockRewards/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUserStockRewards/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUserStockRewards/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUserStockRewards/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserStockRewards/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserStockRewards/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserStockRewards/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserStockRewards/deleteBatch', params, httpOptions);
  }
}
